import React from 'react';

export const AddBlockPlaceholderTiles: React.FC = () => (
  <div className="box-border h-10 w-10 shrink-0 overflow-hidden rounded bg-violet-200 p-2">
    <div className="grid h-full w-full grid-cols-2 grid-rows-2 gap-0.5">
      {[0, 1, 2, 3].map((i) => (
        <div
          key={i}
          role="presentation"
          className="block min-h-0 min-w-0 rounded-[2px] bg-white shadow-sm"
        />
      ))}
    </div>
  </div>
);
